import savingActionTypes from '../../constants/saving-action-types';

const deleteSiteMEta = (selector) => ({
  type: savingActionTypes.DELETE_SITE_META,
  selector,
});

export default deleteSiteMEta;
